import React from "react";
import PropTypes from "prop-types";
import styles from "./Page.module.scss";
import Header from "../Shared/Header/Header";
import User from "../../services/User";
import classNames from "classnames";
import Container from "@material-ui/core/Container";
import Footer from "../Shared/Footer/Footer";
import DesktopMenu from "../Shared/DesktopMenu/DesktopMenu";
//import Scroll from "../../services/Scroll";
import { Scrollbars } from "rc-scrollbars";
//import api from "../../services/Api";
//import ContentBox from "../Shared/ContentBox/ContentBox";

// Scroll.setLeftSide();

class Page extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      boxContent: null,
      showBoxContent: false,
      boxContentTitle: null,
      boxContentSubTitle: null,
      boxContentStep: null,
      boxContentLawyerInfo: false,
      currentLawyer: null,
      imageUrl: undefined,
    };
  }

  childrenWithProps = React.Children.map(this.props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { setBoxContent: this.setBoxContent });
    }
    return child;
  });

  render() {
    return (
      <>
        <Header user={this.props.user} />
        <div
          id="pageContent"
          className={classNames({
            pageContent: true,
            [styles.Page]: true,
          })}
        >
          <DesktopMenu user={this.props.user} />
          <div id="leftSide" className="leftSide">
            {window.screen.availWidth >= 768 && (
              <Scrollbars
                renderTrackVertical={(props) => (
                  <div {...props} className="track-vertical" />
                )}
                renderThumbVertical={(props) => (
                  <div {...props} className="thumb-vertical" />
                )}
                renderTrackHorizontal={(props) => (
                  <div {...props} className="track-horizontal" />
                )}
              >
                <Container maxWidth="lg">{this.childrenWithProps}</Container>
                <Footer />
              </Scrollbars>
            )}
            {window.screen.availWidth < 768 && (
              <>
                <Container maxWidth="lg">{this.childrenWithProps}</Container>
                <Footer />
              </>
            )}
          </div>
          {/*<ContentBox*/}
          {/*    isOpen={this.state.showBoxContent}*/}
          {/*    setBoxContent={this.setBoxContent}*/}
          {/*    title={this.state.boxContentTitle}*/}
          {/*    subtitle={this.state.boxContentSubTitle}*/}
          {/*    step={this.state.boxContentStep}*/}
          {/*    maxStep={this.props.user ? 2 : 3}*/}
          {/*    className={styles.contetnBox}*/}
          {/*    bottomContent={this.state.bottomContent}*/}
          {/*    currentLawyer={this.state.currentLawyer}*/}
          {/*    changeBody={false}*/}
          {/*    boxContentLawyerInfo={this.state.boxContentLawyerInfo}*/}
          {/*    imageUrl={this.state.imageUrl}*/}
          {/*    type={'blog'}*/}
          {/*>*/}
          {/*    {this.state.boxContent}*/}
          {/*</ContentBox>*/}
        </div>
      </>
    );
  }
}

Page.propTypes = {};

Page.defaultProps = {};

export default Page;
